import { logUtil } from 'packages/src'

export default function getItemLocalStorageUtil (key) {
  const logPrefix = `key=${key}`
  logUtil('getItemLocalStorageUtil').debug(`${logPrefix} [start]`)

  if (SERVER) {
    return
  }

  if (!window?.localStorage) {
    logUtil('getItemLocalStorageUtil').debug(`${logPrefix} [noop] no localStorage`)
    return
  }

  return window.localStorage.getItem(key)
}
